// French for the client's contacts & record surface. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Logo': 'Logo',
  'The deck cover lockup renders it as «logo × NAVEN».': 'Le lockup de couverture du deck l\u2019affiche comme « logo × NAVEN ».',
  'no logo on the record': 'aucun logo dans la fiche',
  'Replace logo…': 'Remplacer le logo…',
  'Upload logo…': 'Téléverser un logo…',
  'Remove': 'Retirer',
  'Logo saved — the deck cover uses it.': 'Logo enregistré — la couverture du deck l\u2019utilise.',
  'Client saved': 'Client enregistré',
  'A first or family name is required': 'Un prénom ou un nom de famille est requis',
  'Contact saved': 'Contact enregistré',
  'Client archived — it keeps its history and leaves the active list': 'Client archivé — il conserve son historique et quitte la liste active',
  '{label} deleted — {cascade} went with it': '{label} supprimé — {cascade} est parti avec',
  'nothing else': 'rien d’autre',
  '{label} deleted': '{label} supprimé',
  'Contacts': 'Contacts',
  'Add contact': 'Ajouter un contact',
  'Name': 'Nom',
  'Role': 'Rôle',
  'Email': 'E-mail',
  'Phone': 'Téléphone',
  'Sponsor': 'Sponsor',
  'sponsor': 'sponsor',
  'Edit': 'Modifier',
  'Delete {name}': 'Supprimer {name}',
  'No contacts — gate G0 needs at least one.': 'Aucun contact — le gate G0 en exige au moins un.',
  'Record': 'Dossier',
  'Short name': 'Nom court',
  'Sector': 'Secteur',
  'Every engagement of this client inherits it; an engagement may change its own.': 'Chaque mandat de ce client en hérite ; un mandat peut modifier la sienne.',
  'Correspondence language': 'Langue de correspondance',
  'Status': 'Statut',
  'active': 'actif',
  'archived': 'archivé',
  'Legal entity': 'Entité juridique',
  'e.g. {name} Holdings Limited — the party that signs': 'p. ex. {name} Holding SA — la partie qui signe',
  'Printed on the SOW as the contracting party. Leave empty if it is the same as the name above.': 'Imprimé sur le descriptif des prestations (SOW) comme partie contractante. Laisser vide si identique au nom ci-dessus.',
  'Address line 1': 'Ligne d’adresse 1',
  'Building or house': 'Bâtiment ou maison',
  'Address line 2': 'Ligne d’adresse 2',
  'Street': 'Rue',
  'Post code': 'NPA',
  'City': 'Localité',
  'Country': 'Pays',
  'Notes': 'Notes',
  'Saving…': 'Enregistrement…',
  'Save changes': 'Enregistrer les modifications',
  'Keeps every engagement, contact and document; the client leaves the active list': 'Conserve chaque mandat, contact et document ; le client quitte la liste active',
  'Archived': 'Archivé',
  'Archive': 'Archiver',
  'Created this by mistake? Deleting removes the client and everything under it — engagements, contacts, portal users — immediately and for good.': 'Créé par erreur ? La suppression retire le client et tout ce qui en dépend — mandats, contacts, utilisateurs du portail — immédiatement et définitivement.',
  'Delete client': 'Supprimer le client',
  'Edit contact': 'Modifier le contact',
  'New contact': 'Nouveau contact',
  'First name': 'Prénom',
  'Family name': 'Nom de famille',
  'e.g. 079 411 55 35': 'p. ex. 079 411 55 35',
  'e.g. +41 79 411 55 35': 'p. ex. +41 79 411 55 35',
  'Stored in international format.': 'Enregistré au format international.',
  'Sponsor — signs the SOW and acceptance records': 'Sponsor — signe la SOW et les procès-verbaux d’acceptation',
  'Cancel': 'Annuler',
  'Save contact': 'Enregistrer le contact',
  'Archive client': 'Archiver le client',
  '{label} cannot be deleted': '{label} ne peut pas être supprimé',
  'Delete {label}': 'Supprimer {label}',
  'contact': 'contact',
  'Archive instead': 'Archiver à la place',
  'Got it': 'Compris',
  'Deleting…': 'Suppression…',
  'Delete permanently': 'Supprimer définitivement',
  'Archive “{label}”? Engagements and history are preserved — the client simply drops out of the active list. Nothing is removed, and you can bring it back by setting the status to active.': 'Archiver «{label}» ? Les mandats et l’historique sont conservés — le client sort simplement de la liste active. Rien n’est supprimé, et vous pouvez le ramener en repassant son statut à actif.',
  'Delete “{label}” outright? This is for a client that should never have existed — a real one that has finished gets archived instead.': 'Supprimer «{label}» définitivement ? Ceci est pour un client qui n’aurait jamais dû exister — un client réel arrivé à son terme est archivé à la place.',
  '{count} {what} go with it': '{count} {what} partent avec',
  'Nothing else hangs off this client.': 'Rien d’autre ne dépend de ce client.',
  'Including {codes} with every requirement and run inside them — and the client’s document library, stored files included.': 'Y compris {codes} avec toutes les exigences et exécutions qu’ils contiennent — ainsi que la bibliothèque de documents du client, fichiers stockés inclus.',
  'Immediate and irreversible. The audit log keeps the record.': 'Immédiat et irréversible. La piste d’audit conserve la trace.',
  'Delete “{label}”? The full record is written to the audit log before removal.': 'Supprimer «{label}» ? Le dossier complet est inscrit dans la piste d’audit avant la suppression.',
}, 'ClientContactsRecord');
